import { msg } from '@lingui/core/macro';
import { TASK_SCALE_TYPE } from '@routes/sidebar/___shared___/constants.ts';

export const ELEMENT_TYPE = 'type';
export const ELEMENT_ID = 'id';
export const ELEMENT_CREATOR_REFERENCE = 'creatorReference';
export const ELEMENT_CREATED_BY = 'creator';
export const ELEMENT_CREATED_FOR = 'createdFor';
export const ELEMENT_TITLE = 'title';
export const ELEMENT_LEARNING_OBJECTIVE = 'learningObjective';
export const BACK_ELEMENT_TITLE = 'Title';
export const ELEMENT_RUN_TIME_MINUTES = 'runTimeMinutes';
export const ELEMENT_RUN_TIME_SECONDS = 'runTimeSeconds';
export const ELEMENT_TYPE_PDF_KEY = 'PDF';
export const ELEMENT_TYPE_VIDEO_KEY = 'Video';
export const ELEMENT_TYPE_YOU_TUBE_KEY = 'YouTube';
export const ELEMENT_TYPE_TASK_KEY = 'Task';
export const ELEMENT_TASK_RATING_SCALE = 'taskScaleType';
export const ELEMENT_TASK_SUBTASKS = 'subTasks';
export const ELEMENT_TASK_REFERENCE = 'referenceText';
export const SUBTASK_DESCRIPTION = 'subtaskDescription';
export const ASSESSOR_GUIDELINE = 'assessorGuideline';
export const ELEMENT_PDF_DOCUMENT = 'pdfDocument';
export const ELEMENT_COVER_IMAGE = 'thumbnailURI';
export const ELEMENT_VIDEO = 'video';
export const ELEMENT_YOU_TUBE = 'youTube';
export const ELEMENT_QUESTIONS = 'itemQuizQuestions';
export const ELEMENT_QUESTION = 'question';
export const ELEMENT_TITLE_MAP: Record<string, string> = {
    [ELEMENT_TITLE]: 'Title',
};
export const ELEMENT_TYPES = {
    [ELEMENT_TYPE_PDF_KEY]: msg`PDF`,
    [ELEMENT_TYPE_VIDEO_KEY]: msg`Video`,
    [ELEMENT_TYPE_YOU_TUBE_KEY]: msg`YouTube`,
    [ELEMENT_TYPE_TASK_KEY]: msg`Task`,
};
export const ELEMENT_TASK_RATING_SCALES = {
    [TASK_SCALE_TYPE.TwoPointApprove]: msg`2-point (Approved / Disapproved)`,
    [TASK_SCALE_TYPE.TwoPointConfidence]: msg`2-point (Confident / Not Confident)`,
    [TASK_SCALE_TYPE.FivePointCompetence]: msg`5-point – Competency (BCAV / ICMG)`,
};
const MAX_PDF_SIZE_MB = 15;
const MAX_VIDEO_SIZE_MB = 350;
export const MAX_PDF_SIZE_BYTES = MAX_PDF_SIZE_MB * 1024 * 1024;
export const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;

export const ELEMENT_ENTITY_TYPE = 'ElementAdmin' as const;

export const ELEMENT_VALIDATION_FIELDS_NAMES = {
    // only backend validation fields
    TITLE: 'Title',
    LEARNING_OBJECTIVE: 'LearningObjective',
} as const;
